import React, {useRef, useState} from 'react';

import styles from './styles/upload-box.module.css';

import Button from '../../common-women/Button';

export default function UploadBox({ selectFileList }) {
    const fileFinderRef = useRef(null); // 파일 탐색기

    const [isDragging, setIsDragging] = useState(false);
  
    const openFileFinder = () => {
        fileFinderRef.current.click();
    };
  
    const changeFileList = (e) => {
        if (e.target.files.length > 0) {
            selectFileList(Array.from(e.target.files));
            e.target.value = ''; // 파일 input 초기화
        }
    };

    const preventEvent = (e) => { // 공통 이벤트 처리
        e.preventDefault();
        e.stopPropagation();
    };

    const handleDragEnter = (e) => { // 사용자가 드래그한 파일이 컴포넌트 영역에 들어왔을 때 호출
        preventEvent(e);
        setIsDragging(true);
    };

    const handleDragLeave = (e) => { // 사용자가 드래그한 파일이 컴포넌트 영역을 벗어났을 때 호출
        preventEvent(e);
        setIsDragging(false);
    };

    const handleDragOver = (e) => { // 사용자가 드래그한 파일이 컴포넌트 위에 있는 동안 계속 호출
        preventEvent(e);
        if (!isDragging) {
            setIsDragging(true);
        }
    };

    const handleDrop = (e) => { // 사용자가 파일을 놓았을 때 호출
        preventEvent(e);
        setIsDragging(false);
        
        if (e.dataTransfer.files.length > 0) {
            const acceptedExtensions = ['.pdf', '.hwp', '.hwpx', '.xls', '.xlsx']; // 파일 확장자 필터링

            const uploadableFiles = Array.from(e.dataTransfer.files).filter(file => {
                const fileExtension = '.' + file.name.split('.').pop().toLowerCase();
                return acceptedExtensions.includes(fileExtension);
            });
            
            if (uploadableFiles.length > 0) {
                selectFileList(uploadableFiles);
            }
        }
    };

    return (
        <div 
            className={styles.wrapper}
            onDragEnter={handleDragEnter}
            onDragLeave={handleDragLeave}
            onDragOver={handleDragOver}
            onDrop={handleDrop}
        >
            <p>드래그 앤 드롭으로 파일을 업로드하거나 아래 버튼을 클릭하세요</p>
            <Button
                text='파일 선택'
                width='100px'
                height='36px'
                padding='10px 20px'
                backgroundColor='#825DFC'
                borderRadius='5px'
                fontSize='15px'
                fontWeight='700'
                textColor='#FFF'
                onClick={openFileFinder}
            />
            <input
                ref={fileFinderRef}
                style={{ display: 'none' }}
                type='file'
                onChange={changeFileList}
                accept='.pdf,.hwp,.hwpx,.xls,.xlsx'  // 허용할 확장자 지정
                multiple // 다중 선택 허용
            />
        </div>
    );
}
